module.exports = __webpack_public_path__ + "static/img/sz.5935cfae.png";